module.exports = __webpack_public_path__ + "img/CJ_03.5d1d3763.webp";